/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-11 21:19:00
 **/

import { PropsWithChildren, useEffect } from "react";
import { usePersistStore } from "@/frameworks/core/persistence";
import { useProperties, useBeforeUnload, Properties, Rehydration, Loader } from "@rsupport/libraries";

export default function CheckHydration(props: PropsWithChildren) {
	const store_ready = usePersistStore((state) => state.has_hydrated);
	const properties_ready = useProperties((state) => state.has_hydrated);

	const on_initialize = (): Promise<number> => {
		Properties.instance.update_browser_tab_id();
		return Promise.resolve(0);
	};

	useBeforeUnload(() => {
		Properties.instance.dispose_browser_tab_id();
	});

	useEffect(() => {
		console.log("CheckHydration", "store_ready", store_ready, "properties_ready", properties_ready);
	}, [store_ready, properties_ready]);

	return (
		<Rehydration
			is_hydrated={store_ready && properties_ready}
			on_initialized={on_initialize}
			on_loading={<Loader type="clip" color={"#aaa"} />}
		>
			{props.children}
		</Rehydration>
	);
}
